import { capitalize } from 'lodash'
import get from 'lodash/get';

const SALE_HISTORY_UNIT = {
  DAY: 'D',
  MONTH: 'M',
  YEAR: 'Y',
};

const SPECIAL_SALE_HISTORY_CONSTANT = ['TODAY', 'YESTERDAY', 'THISMONTH', 'THISYEAR'];

const findSaleHistoryDateRange = (numberOfLasting, special, duration) => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth();
  const year = today.getFullYear();
  const dateRange = {
    startDate: '',
    endDate: '',
  };
  const endOfToday = new Date(year, month, day, 23, 59, 59);
  let startDate;
  let endDate;
  if (special && SPECIAL_SALE_HISTORY_CONSTANT.includes(special)) {
    switch (special) {
      case 'TODAY':
        dateRange.startDate = today;
        dateRange.endDate = endOfToday;
        return dateRange;
      case 'YESTERDAY':
        dateRange.startDate = new Date(year, month, day - 1);
        dateRange.endDate = new Date(year, month, day - 1, 23, 59, 59);
        return dateRange;
      case 'THISMONTH':
        dateRange.startDate = new Date(year, month, 1);
        dateRange.endDate = endOfToday;
        return dateRange;
      case 'THISYEAR':
        dateRange.startDate = new Date(year, 0, 1);;
        dateRange.endDate = endOfToday;
        return dateRange;
      default:
        break;
    }
  } else {
    switch (duration) {
      case SALE_HISTORY_UNIT.DAY:
        startDate = new Date(year, month, day - numberOfLasting);
        endDate = new Date(year, month, day - 1, 23, 59, 59);
        break;
      case SALE_HISTORY_UNIT.MONTH:
        startDate = new Date(year, month - numberOfLasting, day - 1);
        endDate = new Date(year, month, day - 1, 23, 59, 59);
        break;
      case SALE_HISTORY_UNIT.YEAR:
        startDate = new Date(year - numberOfLasting, month, day - 1);
        endDate = new Date(year, month, day - 1, 23, 59, 59);
        break;
      default:
        break;
    }
    dateRange.startDate = startDate;
    dateRange.endDate = endDate;
    return dateRange;
  }
};

const isSameDay = (d1, d2) => {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}

const getSaleHistoryUnitKey = saleHistoryUnit => {
  let unitKey;
  Object.keys(SALE_HISTORY_UNIT).forEach(key => {
    if (!unitKey) {
      unitKey = SALE_HISTORY_UNIT[key] === saleHistoryUnit ? key.toLowerCase() : null;
    }
  });
  return unitKey;
}

const buildSaleHistoryData = (saleHistoryViews, intl) => {
  if(saleHistoryViews.length === 0) {
    return [];
  }
  const saleHistoryData = [];

  const endWithDayMonthYearRegex = /[DMY]$/;
  saleHistoryViews.forEach(saleHistory => {
    const saleHistoryObject = {
      label: '',
      value: '',
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
    };
    if (saleHistory.startsWith('LAST') && endWithDayMonthYearRegex.test(saleHistory)){
      const saleHistoryUnit = saleHistory[saleHistory.length - 1];
      const numberOfLasting = saleHistory.substring(saleHistory.indexOf('-') + 1, saleHistory.lastIndexOf('-'));

      saleHistoryObject.label = numberOfLasting > 1
      ? intl.formatMessage(
        {id: `gravity.ProducerDashboard.header.saleHistory.last.${getSaleHistoryUnitKey(saleHistoryUnit)}s`},
        {'0': numberOfLasting}
      )
      : intl.formatMessage(
        {id: `gravity.ProducerDashboard.header.saleHistory.last.${getSaleHistoryUnitKey(saleHistoryUnit)}`},
      )

      saleHistoryObject.label = capitalize(saleHistoryObject.label.replace(/-/g, ' '));
      saleHistoryObject.dateRange = findSaleHistoryDateRange(numberOfLasting, null, saleHistoryUnit)
    } else if (SPECIAL_SALE_HISTORY_CONSTANT.includes(saleHistory)){
      saleHistoryObject.label = intl.formatMessage(
        {id: `gravity.ProducerDashboard.header.saleHistory.${saleHistory.toLowerCase()}`}
      );
      saleHistoryObject.label = capitalize(saleHistoryObject.label);
      saleHistoryObject.dateRange = findSaleHistoryDateRange(null, saleHistory, null);
    }

    saleHistoryObject.value = saleHistory;
    saleHistoryData.push(saleHistoryObject);
  })
  return saleHistoryData;
}

const getSaleHistoryViews = props => {
  const SALE_HISTORY_VIEW_KEY = 'function.producerSpace.dashboard.saleHistoryView';
  const saleHistoryViews = get(props.translations, `${props.language || props.defaultLanguage}['${SALE_HISTORY_VIEW_KEY}']`, '');
  if(saleHistoryViews){
    return saleHistoryViews.split('|');
  }
  return [];
}

export {
  SALE_HISTORY_UNIT,
  SPECIAL_SALE_HISTORY_CONSTANT,
  buildSaleHistoryData,
  isSameDay,
  getSaleHistoryViews
}

